import React, { useRef, useState,useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import './EmplAssessment.css';
import { Util } from '../../../config/Util';
function LaunchAssessment(arg) {
  const [show, setShow] = useState(arg.flag);
  const [trainingStarted , setTrainingStarted] = useState(false);
  const [counter, setCounter] = useState(0);
  const [finish, setFinish] = useState(false);
  const [pass, setPass] = useState(false);
  const [date,setDate]  = useState(new Date());
  const [cert, setCert] = useState('');
  const duration = useRef('');
  const answerMap = useRef({});
  const selectedRadio = useRef('');
  const timer = useRef('');
  const [question, setQuestion] = useState('');
  const [cord, setCord] = useState('');
  const [submit, setSubmit] = useState(false);
  const [percentage, setPercentage] = useState(0);

  const handleClose = () => {
    setShow(false);
    clearInterval(timer.current);
    arg.handler();
  }
  const handleShow = () => setShow(true);

  useEffect(() => {
    const {data} = arg;
    const question = data.questions || [];
    //if(question.length)
    // question.sort((a, b) => (a.id > b.id) ? 1 : -1)
    setQuestion(question);
  }, [])
  
  //Validate if attempts are allowed
  const validateAttempt =()=>{
    const req = {
      assessmentId: arg.data.id
    }
    arg.validateAttept(req,(resp)=>{
      if(resp === "Y"){
        startTraining();
      }
    });
  }
 
  //Start training
  const startTraining = ()=>{
    const {data} = arg;
    duration.current = data.duration;
    //Timestamp after duration
    clearInterval(timer.current);
    const endTime = new Date(new Date().getTime() + (data.duration)*60000);
    timer.current = setInterval(()=>{
      let now = new Date().getTime();
      let distance = endTime - now;
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if(minutes < 10) minutes = "0"+minutes;
      if(seconds < 10) seconds = "0"+seconds;
      document.getElementById("timer-clock").innerHTML = minutes +" : "+ seconds; 
      if(minutes == 0 && seconds == 0){
        handleFinishClick();
      }
    },1000)
    setTrainingStarted(true);
  }
  //Next 
  const handleNextClick =(q)=>{
    
    if((counter+1) === question.length) return;
    setCounter(counter+1);
  }
  //Previous
  const handlePreviousClick =()=>{
    if(counter >0) setCounter((counter-1));
  }
  //Finish
  const handleFinishClick=()=>{
    clearInterval(timer.current);
    setShow(false);

    if(arg.data.assessmentType === 2 || arg.data.assessmentType === 3){
      const req= {
        assessmentId: arg.data.id,
        response: answerMap.current
      }
      //Call finish api to update the status
      arg.updateStatus(req,(resp)=>{
        setShow(true);
        setFinish(true);
        if(resp.result === "P"){
          setCert(resp.certificateUrl); 
          setPercentage(resp.percentage);
          setPass(true);
        }
        if(resp.result === "S"){
          setSubmit(true);
        }
      });
    }else if(arg.data.assessmentType === 1){
      const map = {
        0 : 'a',
        1 : 'b',
        2 : 'c',
        3 : 'd',
        4 : 'e'
      }
  
      Object.keys(answerMap.current).forEach((key)=> { 
        let val = answerMap.current[key];
        answerMap.current[key] = map[val];  
      });
      const req= {
        assessmentId: arg.data.id,
        response: answerMap.current
      }
      //Call finish api to update the status
      arg.updateStatus(req,(resp)=>{
        setShow(true);
        setFinish(true);
        if(resp.result === "P"){
          setCert(resp.certificateUrl); 
          setPercentage(resp.percentage);
          setPass(true);
        }
      });
    }
   
  }
  const handleAnswerSelection=(q,index)=>{
    selectedRadio.current=index; 
    answerMap.current[q.id] = selectedRadio.current;
    setDate(new Date()); //This is to force a re render
  }

  const renderTargetBox=(cord)=>{
    setTimeout(() => {
      if(!cord) return;
      let cordArray = cord.split(",");
      let nums = cordArray.map(function(str) {
        return parseInt(str); });
      var rectDiv = document.getElementById('user-target');
      if(rectDiv){
        rectDiv.style.display = 'block';
        rectDiv.style.position = 'absolute';

        rectDiv.style.left = nums[0] + 'px';
        rectDiv.style.top = nums[1] + 'px';
        rectDiv.style.width = nums[2] + 'px';
        rectDiv.style.height = nums[3] + 'px';
      }
    }, 900);


  }

  const checkUserClick=(e,q)=>{
    //Put a dot to highlight the clicked area
    document.querySelectorAll(".click-dot").forEach(el => el.remove());
    try{
      //parent offeset
     const a = document.getElementById("img-cont");
     const offset =a.getClientRects()[0];
     const leftOff = offset.left;
     const topOff = offset.top;

    const mouseX = e.pageX - leftOff;
    const mouseY = e.pageY - topOff;
    var color = '#000000';
    var size = '30px';

    let clickedArea = document.createElement('div');
    clickedArea.classList.add("click-dot")
    clickedArea.style.position = 'absolute';
    clickedArea.style.left =  mouseX+ 'px';
    clickedArea.style.top =  mouseY+ 'px';
    clickedArea.style.width = size;
    clickedArea.style.height = size;
    clickedArea.style.backgroundColor = color;
    clickedArea.style.zIndex = 9999;
    clickedArea.style.borderRadius = '50%';
    clickedArea.style.opacity = 0.5;

    const img = document.getElementById('img-cont');
    img.appendChild(clickedArea);
    }catch(e){
      console.log("Exception while marking the clicked area");
    }
   
    if(e.target.id === 'user-target'){
      answerMap.current[q.id] = 'Y';
    }else{
      answerMap.current[q.id] = 'N';
    }
  }

  const handleDescriptiveAnswer=(e,q)=>{
    answerMap.current[q.id] = e.target.value;
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false} size="lg">
        <Modal.Header>
          <Modal.Title>Assessment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {
                finish && 
                <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  {
                    submit ? <Form.Label>You have successfully submitted the assessment. 
                      It will be reviewed by Admin.
                   
                  </Form.Label>:""
                  }
                  { pass ? <Form.Label>Congratulations! You have successfully completed the assessment - 
                    <br></br>
                    <b>{arg.data.name}</b>
                    <br></br>
                    <Form.Label>Your Score : {percentage} %</Form.Label>
                    <br></br>
                    <a href={Util.baseURlForDownload+cert} download> Download Certificate</a>
                  </Form.Label>
                  :( (submit === false) ?
                    <Form.Label>Sorry! You couldn't score enough. Please try again! 
                      <br></br>
                      <Form.Label>Your Score : {percentage} %</Form.Label>
                    </Form.Label> : ""
                  )
                  }
                  
                </Form.Group>
              </Form>
            }
            {
                !trainingStarted && <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Title</Form.Label>
                  <Form.Control value={arg.data.name} type="text" disabled/>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control as="textarea" rows={3} value={arg.data.description} disabled />
                </Form.Group>
                
              </Form>
            }
            {
                (trainingStarted && !finish) && 
                    question.map((q,i)=>{
                        let opArray=[q.option1,q.option2,q.option3,q.option4,q.option5];
                        const qid = q.id;
                        if(i === counter){
                            return(
                            
                                <>
                                <Form key={i}>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label className='text-underline'>Question {i+1} of {question.length}</Form.Label>
                                <br></br>
                                <Form.Label >{q.question}</Form.Label>
                                {
                                  q.image ? 
                                  <div className='mb-1'>
                                    <img id="output" width="200" height="200" src={Util.baseURlForDownload+q.image}/>
                                  </div>
                                  :''
                                }
                                </Form.Group>
                                { (arg.data.assessmentType === 1) &&
                                  opArray.map((op,index)=>{
                                    return(                                
                                      <div className='mb-2'>
                                        <input type='radio' name='option' className=''  value={op} onChange={()=> {handleAnswerSelection(q,index)}} checked={answerMap.current[q.id] == index}></input>
                                        <label className='op-label'>{op}</label>
                                      </div>
                                    )
                                  })
                                }
                                {
                                    (arg.data.assessmentType === 2) &&   <Form.Group className="mb-3 col-md-6">
                                    
                                    <div id="img-cont" onClick={(e)=>checkUserClick(e,q)}>
                                      <img id="output-img" width="500" height="500" src={Util.baseURlForDownload+q.image}/>
                                      <div id="user-target"></div>
                                      {renderTargetBox(q.answer)}
                                    </div>
                                    
                                    <div id="bounds"></div>
                                    </Form.Group>

                                }
                                  {
                                    (arg.data.assessmentType === 3) &&   <Form.Group className="mb-3 col-md-12">
                                     <div className='mb-2'>
                                      <textarea className='form-control' onChange={(e)=>handleDescriptiveAnswer(e,q)}></textarea>
                                      </div>
                                    
                                    </Form.Group>

                                }
                              
                                
                                </Form>
                                <Modal.Footer className='footer-btn-actions'>
                                  
                                <Button variant="primary" onClick={handlePreviousClick}>
                                  PREVIOUS
                                </Button>
                                {/* <Button variant="primary" onClick={handleNextClick}>
                                  NEXT
                                </Button> */}
                                {
                                    counter === (question.length-1) ?
                                    <Button variant="success" onClick={()=>handleFinishClick(qid)}>
                                    FINISH
                                    </Button> :
                                    <Button variant="primary" onClick={()=>handleNextClick(qid)}>
                                    NEXT
                                    </Button>
                                }
                              </Modal.Footer>
                                </>
                        )
                        }
                        
                    })
            }
            { (trainingStarted && !finish) && 
            <div className='timer-div'>
            Time Remaining &nbsp;<span id='timer-clock'></span><span> &nbsp; Minutes</span>
            </div>
            }
              
          
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CLOSE
          </Button>
          {
            !trainingStarted &&   <Button variant="primary" onClick={validateAttempt}>
            START
          </Button>
          }
            
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LaunchAssessment;

